import { isCurrentBrowserTestEnvironment } from "@/lib/test-environment";

export type LocalStorageKeys =
  | "complete-list-of-players"
  | "complete-list-of-attitudes"
  | "complete-list-of-missions"
  | "filtered-list-of-attitudes"
  | "complete-list-of-games"
  | "badAttitudes"
  | "goodAttitudes"
  | "objectives"
  | "completeMissions"
  | "collapsed"
  | "complete-list-of-rewards"
  | "userAccessLevel"
  | "AllClasses"
  | "raw-list-of-players";

export class Constants {
  static LSK_AllClasses: LocalStorageKeys = "AllClasses";
  static LSK_UserAccessLevel: LocalStorageKeys = "userAccessLevel";
  static LSK_Collapsed: LocalStorageKeys = "collapsed";
  static LSK_GamesSelect = (multiple: boolean) => {
    return "GamesSelect games" + (multiple ? " multiple" : "");
  };
  static LSK_ClassesSelect = (multiple: boolean) => {
    return "ClassesSelect classes" + (multiple ? " multiple" : "");
  };
  static LSK_CompletedMissions: LocalStorageKeys = "completeMissions";
  static LSK_OldMissions: LocalStorageKeys = "objectives";
  static LSK_BadAttitudes: LocalStorageKeys = "badAttitudes";
  static LSK_GoodAttitudes: LocalStorageKeys = "goodAttitudes";
  static LSK_Games: LocalStorageKeys = "complete-list-of-games";
  static LSK_Missions: LocalStorageKeys = "complete-list-of-missions";
  static LSK_RawPlayers: LocalStorageKeys = "raw-list-of-players";
  static LSK_FullPlayers: LocalStorageKeys = "complete-list-of-players";
  static LSK_Rewards: LocalStorageKeys = "complete-list-of-rewards";
  static LSK_Attitudes: LocalStorageKeys = "complete-list-of-attitudes";
  static LSK_Attitudes_Filtered: LocalStorageKeys = "filtered-list-of-attitudes";

  static isTestEnvironment() {
    return isCurrentBrowserTestEnvironment();
  }

  static hostName() {
    if (typeof window === "undefined") {
      return "";
    }
    return window.location.hostname;
  }
}
